class ManageLayerList {
	constructor () {
		this._activeTimeline = null;

		this._dialog = Dialog.Modal(
			'manage-layers',
			_("Active timeline layers"),
			LARGE,
			null,
			this._elem = UI.div()
		);
		this._dialog.head = UI.div(
			'text-end flex gap-2 justify-end',
			[
				nav.userCan(MemberPermission.ADMIN) && nav.isCircle
					? new ContentFilter(MemberPermission.FILTER_LAYERS, () => this.getData(this._activeTimeline)).button
					: null,
				this._addBtn = UI.priIconBtn('plus-square', 22, {'click': this.addLayer.bind(this)})
			]
		);

		this._owner = null;
		this._layerCount = 0;
	}

	get timeline() { return this._activeTimeline; }

	getData(timelineId) {
		this._activeTimeline = timelineId;
		this._elem.innerHTML = '';

		API.fetch(`timelines/${timelineId}/layers`)
		.then(reply => {
			if (showError(reply)) return;

			this.owned = ManageLayerOwner.fromMap(
				{
					"name": reply.user == reply.center.id ? _("My Layers") : _(`${reply.center.name}'s Layers`)
				},
				this
			);
			this.other = ManageLayerOwner.fromMap(
				{
					"name": _("Other Layers")
				},
				this
			);

			this._elem.appendChild(this.owned.elem);
			this._elem.appendChild(this.other.elem);

			if (reply.layers && Array.isArray(reply.layers) && reply.layers.length) {
				for(let data of reply.layers) {
					let layer = ManageLayer.fromArray(data, reply.center, this);
					if (layer.ownerId == reply.center.id) {
						this.owned.addLayer(layer);
					}
					else {
						this.other.addLayer(layer);
					}
				}

				if (reply.access && reply.units) {
					let unitCount = reply.units.length;
					let parentId = reply.units[0].unit_id;
					let summary = {};
					let parentAccess = {};

					for (let a of reply.access) {
						let id = a.layer_id;
						if (!summary[id]) summary[id] = { view: 0, edit: 0 };
						if (a.access_mode >= 1) summary[id].view++;
						if (a.access_mode >= 2) summary[id].edit++;
						if (parseInt(a.entity_id) === parseInt(parentId)) {
							parentAccess[id] = parseInt(a.access_mode);
						}
					}
					for (let id in summary) {
						let pa = parentAccess[id] || 0;
						if (pa >= 1) summary[id].view = unitCount;
						if (pa >= 2) summary[id].edit = unitCount;
						layerAccess.setSummary(parseInt(id), summary[id].view, summary[id].edit, unitCount);
					}
				}
				if (reply.sharing_summary) {
					for (let s of reply.sharing_summary) {
						layerSharing.setCount(parseInt(s.id), parseInt(s.share_count));
					}
				}
			}
			else this.emptyMessage();

			document.dispatchEvent(new Event('tipsAdded'));			
		});
	}

	open(timeline) {
		this.getData(timeline.id);
		this._dialog.name = _('Available layers for ' + timeline.name);
		this._dialog.open(null, this.close);
	}

	close() {
		document.dispatchEvent(new Event('primaryDataInvalid'));
	}

	addLayer() {
		let newLayer = ManageLayer.blank(this);
		this.owned.addLayer(newLayer);
		this._layerCount++;
		newLayer.edit();
	}

	remove (managedLayer) {
		if (this._owner !== null) {
			this._owner.removeLayer(managedLayer);
		}
		else {
			this._elem.removeChild(managedLayer.elem);
		}
		this._layerCount--;
		this.emptyMessage();
	}

	emptyMessage() {
		if (this._layerCount == 0) {
			this._elem.appendChild(UI.htm('h4', 'text-xl p-5 text-center', _("Click the + symbol to add the first layer!")));
		}
	}
}
